import React from 'react'

import Image from 'next/image'
import StatsComponent from '../StatsComponent'
import { MaterialsItem } from '@/redux/services/materialsApi'
import Link from 'next/link'



interface Props {
    item: MaterialsItem | any
}



const UsefulMatCard: React.FC<Props> = ({ item }) => {

    // 


    return (
        <Link href={`/useful-materials/${item.translit}`}>
            <div draggable key={item.id} className='useful-materials__card'>
                <div className="useful-materials__card-animal">
                    <Image
                        width={257}
                        height={239}
                        src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.preview}`}
                        alt='animal' />
                </div>
                <div className="useful-materials__card-text-content">
                    <ul className="useful-materials__card-types">
                        {item.tags_id?.map((tag) => (
                            <li key={tag.title}>{tag.title}</li>
                        ))}
                        <p className="useful-materials__card-date">
                            {item.creation_date?.split('T')[0].split('-')[2]}.
                            {item.creation_date?.split('T')[0].split('-')[1]}.
                            {item.creation_date?.split('T')[0].split('-')[0]}
                        </p>
                    </ul>
                    <h3 className="useful-materials__card-title">{item.title}</h3>
                    <p className="useful-materials__card-description"
                    >{item.subtitle}</p>
                    {/* dangerouslySetInnerHTML={{ __html: item.description }} */}
                    <StatsComponent likes={item.likes} views={item.views} />
                </div>
            </div>
        </Link>
    )
}

export default UsefulMatCard
